import styled from 'styled-components'

export const Container = styled.div``

export const Main = styled.p`
  margin-bottom: var(--space-300);
`

export const Description = styled.div`
  margin-bottom: var(--space-200);
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
`
